import React from 'react';

import {
  BarChartReportCard,
  LabelReportCard,
  PieChartReportCard,
  TableReportCard,
  XYChartReportCard,
} from './components';
import { ReportCardProps } from './types';

export const ReportCard = ({
  cellFormatter,
  clearFilters,
  columnFormatter,
  description,
  query,
  sx,
  title,
  variant,
}: ReportCardProps) => {
  switch (variant.type) {
    case 'label': {
      return (
        <LabelReportCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
        />
      );
    }
    case 'bar_chart': {
      return (
        <BarChartReportCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
          variantProps={variant}
        />
      );
    }
    case 'pie_chart': {
      return (
        <PieChartReportCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
          variantProps={variant}
        />
      );
    }
    case 'table': {
      return (
        <TableReportCard
          cellFormatter={cellFormatter}
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
        />
      );
    }
    case 'xy_chart': {
      return (
        <XYChartReportCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
          variantProps={variant}
        />
      );
    }
    default: {
      throw new Error('Assign a valid widget type in the display configuration');
    }
  }
};
